import VariantModel from '../VariantModel';
import {IProductPriceObject} from '../IProduct';
import AbstractPriceModel from '../AbstractPriceModel';

/**
 * Represents Variant VariantPriceModel
 */
class VariantPriceModel extends AbstractPriceModel {
	variantModel: VariantModel;

	/**
	 * @param {VariantModel} variantModel - variant model
	 */
	constructor(variantModel: VariantModel) {
		super(variantModel);

		this.variantModel = variantModel;
	}

	/**
	 * Returns the minimal price taking into consideration the Product Promotions
	 * @return {IProductPriceObject} The minimal price
	 */
	getMinPrice(): IProductPriceObject {
		const promotionalPrice = this.variantModel
			.getProductPromotions()
			.reduce((promotionalPrice: number, promotion) => {
				const currentPromotionalPrice = promotion.promotionalPrice;

				return !promotionalPrice || promotionalPrice > currentPromotionalPrice
					? currentPromotionalPrice
					: promotionalPrice;
			}, null);

		if (promotionalPrice) {
			return {
				currency: this.variantModel.getPriceCurrency(),
				value: promotionalPrice,
				pricebook: 'promotional',
			};
		}

		return this.variantModel.getPrice();
	}

	/**
	 * Returns the maximum price
	 * @returns {IProductPriceObject} - the maximum price
	 */
	getMaxPrice(): IProductPriceObject {
		const tieredPrice = this.variantModel.getTieredPrices();

		const maxPrice: IProductPriceObject = tieredPrice?.reduce(
			(maxPriceObj: IProductPriceObject, priceRange) => {
				if (priceRange.price > maxPriceObj.value) {
					return {
						currency: this.variantModel.getPriceCurrency(),
						value: priceRange.price,
						pricebook: priceRange.pricebook,
					};
				} else {
					return maxPriceObj;
				}
			},
			{
				value: 0,
				currency: this.variantModel.getPriceCurrency(),
				pricebook: 'default',
			},
		);

		return maxPrice && maxPrice.value ? maxPrice : this.variantModel.getPrice();
	}
}

export default VariantPriceModel;
